import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M47.1701 15.95C47.1701 19.05 46.2601 21.92 44.7101 24.31C42.1201 28.29 23.4201 28.29 20.8301 24.31C19.2801 21.92 18.3701 19.05 18.3701 15.95C18.3701 7.69 24.8201 1 32.7701 1C40.7201 1.01 47.1701 7.7 47.1701 15.95Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M5.40999 65.49C5.40999 65.49 3.9 50.8 10.61 43.04C17.32 35.28 30.59 33.13 32.93 28.34V17.44C32.93 17.44 18.05 16.45 7.84004 29C-0.469962 39.22 0.209985 56.07 5.40999 65.49Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M60.1299 65.49C60.1299 65.49 61.6399 50.8 54.9299 43.04C48.2199 35.28 34.9499 33.13 32.6099 28.34V17.44C32.6099 17.44 47.4898 16.45 57.6998 29C66.0098 39.22 65.3299 56.07 60.1299 65.49Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
